module.exports = __webpack_public_path__ + "static/media/FAQ CFX_KotakBank_final_kotak_V3 (1)_19.04.cf61a369.pdf";